import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.095 15.03A8.256 8.256 0 0 0 9.75 1.5 8.254 8.254 0 0 0 1.5 9.75a8.254 8.254 0 0 0 13.53 6.345l5.438 5.438 1.064-1.066-5.437-5.437ZM3 9.75C3 6.03 6.03 3 9.75 3s6.75 3.03 6.75 6.75-3.03 6.75-6.75 6.75S3 13.47 3 9.75Z" })
});
export default SvgSearch;
